import { createApi } from '@reduxjs/toolkit/query/react'
import { ADD_ASSESSMENT_GOALS_STRATEGY, COPY_REPORTS, CREATE_BLANK_REPORT, CREATE_CHATTER_SUMMARY_GOAL, DELETE_ASSESSMENT_GOALS_STRATEGY, DELETE_CLIENT_REPORT, GET_ASSESSMENT_GOALS_LIST, GET_REPORT_ASSESMENT_FEEDBACK, SUBMIT_ASSESSMENT_REPORT, SUBMIT_CONSULTATION_REPORT, SUBMIT_INDIVIDUAL_SESSION_REPORT, SUBMIT_SCHOOL_DISCHARGE_SCREENING_REPORT, SUBMIT_TREATMENT_SUMMARY_REPORT } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { schoolClientsApi } from '../school.client';
import { resourceApi } from "store/services/resource";
import { generatePath } from 'react-router-dom';

export const schoolReportsApi = createApi({
    reducerPath: 'schoolReportsApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/reports",
    }),
    tagTypes: [],
    endpoints: (builder) => ({

        // // chatter client details
        // assignApprentice: builder.mutation({
        //     query: ({ caseloadId, apprentice, currentApprenticeId }) => ({
        //         method: "PUT",
        //         url: `${ASSIGN_APPRENTICE}/${caseloadId}/${apprentice}/${currentApprenticeId}`
        //     })
        // }),

        // // chatter client evaluate
        // evaluatePeer: builder.mutation({
        //     query: ({ programId, peerId, data }) => ({
        //         method: "POST",
        //         url: `${EVALUATE_PEER}/${programId}/${peerId}`,
        //         data
        //     })
        // }),

        // clients list lookup
        getReportClientsAssessmentFeedback: builder.query({
            query: ({ reportId, clientId, submittedReportId, clientType = "school" }) => ({
                method: "GET",
                url: `/${clientType}/${GET_REPORT_ASSESMENT_FEEDBACK}/${reportId}/${clientId}${submittedReportId ? `/${submittedReportId}` : ""}`,
                // data
            }),
            transformResponse: (response) => {
                return response.data;
            },
        }),

        submitSchoolDischargeScreeningReport: builder.mutation({
            query: ({ clientId, data }) => ({
                method: "PATCH",
                url: `${SUBMIT_SCHOOL_DISCHARGE_SCREENING_REPORT}/${clientId}`,
                data
            }),
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    // Manually invalidate cache for 'Post' tag
                    dispatch(schoolClientsApi.util.invalidateTags(['SchoolClients']));
                    dispatch(resourceApi.util.invalidateTags(["reportsList"]));
                } catch (error) {
                    // handle error if needed
                    console.log('error', error)
                }
            },
        }),
        submitIndividualSessionReport: builder.mutation({
            query: ({ clientId, data, clientType = "school" }) => ({
                method: "PATCH",
                url: `/${clientType}${SUBMIT_INDIVIDUAL_SESSION_REPORT}/${clientId}`,
                data
            }),
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    // Manually invalidate cache for 'Post' tag
                    dispatch(schoolClientsApi.util.invalidateTags(['SchoolClients']));
                    dispatch(resourceApi.util.invalidateTags(["reportsList"]));
                } catch (error) {
                    // handle error if needed
                    console.log('error', error)
                }
            },
        }),

        submitConsulatitonReport: builder.mutation({
            query: ({ clientType = "school", clientId, data }) => ({
                method: "PATCH",
                url: `/${clientType}${SUBMIT_CONSULTATION_REPORT}/${clientId}`,
                data
            }),
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    // Manually invalidate cache for 'Post' tag
                    dispatch(schoolClientsApi.util.invalidateTags(['SchoolClients']));
                    dispatch(resourceApi.util.invalidateTags(["reportsList"]));
                } catch (error) {
                    // handle error if needed
                    console.log('error', error)
                }
            },
        }),

        submitAssessmentReport: builder.mutation({
            query: ({ clientId, data, clientType = "school" }) => ({
                method: "PATCH",
                url: `/${clientType}${SUBMIT_ASSESSMENT_REPORT}/${clientId}`,
                data
            }),
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    // Manually invalidate cache for 'Post' tag
                    dispatch(schoolClientsApi.util.invalidateTags(['SchoolClients']));
                    dispatch(resourceApi.util.invalidateTags(["reportsList"]));
                } catch (error) {
                    // handle error if needed
                    console.log('error', error)
                }
            },
        }),

        addAssessmentGoalStrategy: builder.mutation({
            query: ({ assessmentId, data }) => ({
                method: "PATCH",
                url: `${ADD_ASSESSMENT_GOALS_STRATEGY}/${assessmentId}`,
                data
            }),
        }),

        deleteAssessmentGoalStrategy: builder.mutation({
            query: ({ assessmentId, data }) => ({
                method: "PATCH",
                url: `${DELETE_ASSESSMENT_GOALS_STRATEGY}/${assessmentId}`,
                data
            }),
        }),


        createChatterSummaryGoal: builder.mutation({
            query: ({ clientType, assessmentId, data }) => ({
                method: "POST",
                url: `/${clientType}${CREATE_CHATTER_SUMMARY_GOAL}/${assessmentId}`,
                data
            }),
        }),

        copyReports: builder.mutation({
            query: ({ assessmentId, clientId, reportId, clientType, reportType, screening_date }) => ({
                method: "PATCH",
                url: generatePath(COPY_REPORTS, { assessmentId, clientId, reportId, clientType, reportType, screening_date }),
            }),
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(resourceApi.util.invalidateTags(["reportsList"]));
                } catch (error) {
                    // handle error if needed
                    console.log('error', error)
                }
            },
        }),

        createBlankReport: builder.mutation({
            query: ({ clientType, assessmentId, clientId }) => ({
                method: "PATCH",
                url: generatePath(CREATE_BLANK_REPORT, { assessmentId, clientId, clientType }),
            }),
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(resourceApi.util.invalidateTags(["reportsList"]));
                } catch (error) {
                    console.log('error', error)
                }
            },
        }),

        deleteClientReport: builder.mutation({
            query: ({ clientType, reportId, reportType }) => ({
                method: "DELETE",
                url: generatePath(DELETE_CLIENT_REPORT, { clientType, reportId, reportType }),
            }),
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(resourceApi.util.invalidateTags(["reportsList"]));
                } catch (error) {
                    // handle error if needed
                    console.log('error', error)
                }
            },
        }),

        submitTreatmentSummaryReport: builder.mutation({
            query: ({ clientId, data, clientType = "school" }) => ({
                method: "PATCH",
                url: `/${clientType}${SUBMIT_TREATMENT_SUMMARY_REPORT}/${clientId}`,
                data
            }),
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    // Manually invalidate cache for 'Post' tag
                    dispatch(schoolClientsApi.util.invalidateTags(['SchoolClients']));
                    dispatch(resourceApi.util.invalidateTags(["reportsList"]));
                } catch (error) {
                    // handle error if needed
                    console.log('error', error)
                }
            },
        }),

        getAssessmentGoalsList: builder.query({
            query: ({ clientType = "school", page = 1, limit = 10, assessmentId = 10, clientId, start_date, end_date }) => {
                return ({
                    method: "PATCH",
                    url: generatePath(GET_ASSESSMENT_GOALS_LIST, { clientType, assessmentId: 10, clientId }),
                    data: { page, limit, start_date, end_date }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["assessmentGoalsList"]
        }),

        createMultipleGoals: builder.mutation({
            query: ({ assessmentId, data, clientType }) => ({
                url: `/${clientType}/assesment-goals/bulk-create/${assessmentId}`,
                method: 'POST',
                data,
            })
        }),

    })
})

export const {
    useGetReportClientsAssessmentFeedbackQuery,
    useSubmitSchoolDischargeScreeningReportMutation,
    useSubmitIndividualSessionReportMutation,
    useSubmitConsulatitonReportMutation,
    useSubmitAssessmentReportMutation,
    useAddAssessmentGoalStrategyMutation,
    useDeleteAssessmentGoalStrategyMutation,
    useCreateChatterSummaryGoalMutation,
    useCopyReportsMutation,
    useCreateBlankReportMutation,
    useDeleteClientReportMutation,
    useSubmitTreatmentSummaryReportMutation,
    useGetAssessmentGoalsListQuery,
    useCreateMultipleGoalsMutation,
} = schoolReportsApi;